import axios from 'axios';
import { from } from 'rxjs';

export const setRefundAssistStatus = async (val) => {
  const response = await axios.post('/refund-assist/enable', {
    shouldEnableRefundAssist: val,
  });

  if (response.status !== 200) {
    throw new Error(`API request failed with status ${response.status}`);
  }

  return response;
};

export const cancelShipmentRefundsAsync = (fulfillmentIds) => {
  const getAndTransform = axios.post('shipment/refunds/cancel', { fulfillmentIds }).then((response) => {
    return response;
  });
  return from(getAndTransform);
};
